export default function debounce(fn) {
  let delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 300;
  let timer;
  const invoke = function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    clearTimeout(timer);
    timer = setTimeout(() => fn(...args), delay);
  };
  const clear = () => {
    clearTimeout(timer);
    timer = undefined;
  };
  return {
    invoke: invoke,
    clear
  };
}
//# sourceMappingURL=index.js.map